import { Currency } from '@uniswap/sdk-core'
import DoubleCurrencyLogo from 'components/DoubleLogo'
import { useToken } from 'hooks/Tokens'
import React from 'react'

const PoolLogo: React.FC<{ tokenA: string; tokenB: string; size?: number }> = ({ tokenA, tokenB, size }) => {
  const currencyA = useToken(tokenA)
  const currencyB = useToken(tokenB)

  return (
    <DoubleCurrencyLogo size={size ? size : 20} currency0={currencyA as Currency} currency1={currencyB as Currency} />
  )
}
export default PoolLogo
